import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Document } from 'contracts/Documents';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_DOCUMENT_',
  }
);

export interface FetchDocumentState {
  data: Document | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchDocumentRequestAction {
  id: number;
  onSuccess?: (data: Document) => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Document;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchDocumentState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchDocumentState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchDocumentState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchDocumentState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchDocumentState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchDocument = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchDocumentTypes = Types;
export const FetchDocumentActions = Creators;
